/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Button from "../../../../../components/button";
import { AISparkles, AISparklesIcon } from "../../../../../assets/images";
import {
    GetTalentSuggestionReason
} from "../../../../../services/previouslyHired";
import "./index.scss";

const AIExplanationBox = ({ instrId, projectId }) => {
    const [displayText, setDisplayText] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [analysisStarted, setAnalysisStarted] = useState(false);
    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const [aiExplanation, setAiExplanation] = useState(null);
    const fullTextRef = useRef("");

    const handleAnalysisStart = async () => {
        setIsAnalyzing(true);
        const payload = {
            projectId: parseInt(projectId, 10),
            instrId: parseInt(instrId, 10)
        };
        
        try {
            const response = await GetTalentSuggestionReason(payload);
            if (response && response.data) {
                var responseData = response.data;
                setAiExplanation(responseData.data);
                fullTextRef.current = responseData.data;
                setIsAnalyzing(false);
                setAnalysisStarted(true);
            }
        } catch (error) {
            console.error("Error fetching AI explanation:", error);
            setIsAnalyzing(false);
        }
    };

    useEffect(() => {
        let typingInterval = null;

        if (analysisStarted && !isTyping) {
            fullTextRef.current = aiExplanation;
            setDisplayText("");
            setIsTyping(true);
            
            let i = 0;
            const fullText = aiExplanation || "";
            
            // Create a more natural typing effect
            const getRandomTypingSpeed = () => {
                // Most characters are typed quickly, with occasional pauses
                const options = [
                    1, 1, 5, 5, 5, 10, 10, 10, 10, 10, 
                    10, 10, 10, 10, 10, 15, 20, 30, 50, 60
                ];
                return options[Math.floor(Math.random() * options.length)];
            };
            
            const typeNextChar = () => {
                if (i < fullText.length) {
                    setDisplayText(prev => prev + fullText.charAt(i));
                    i++;
                    const delay = fullText.charAt(i-1).match(/[.,!?]/) ? 
                        getRandomTypingSpeed() + 40 : getRandomTypingSpeed();
                    
                    typingInterval = setTimeout(typeNextChar, delay);
                } else {
                    clearTimeout(typingInterval);
                    setIsTyping(false);
                }
            };
            
            typingInterval = setTimeout(typeNextChar, 100);
        }

        return () => {
            if (typingInterval) {
                clearTimeout(typingInterval);
            }
        };
    }, [analysisStarted]);

    return (
        <div className="ai-explanation-box ml-3">
            {analysisStarted && (<div className="ai-explanation-header">
                <div className="ai-explanation-title">
                    {isTyping ? (<div className="typing-indicator">
                            <>
                                <span></span>
                                <span></span>
                                <span></span>
                            </>
                    </div>) : (
                        <img 
                            src={AISparklesIcon} 
                            style={{ width: "24px", height: "24px" }}
                            alt="AI Sparkles" 
                            className="ai-sparkles-icon" />
                    )}

                     <div className="font20Black boldFont">Match Logic</div>
                </div>
            </div>)}
            <div className="ai-explanation-content">
                {!analysisStarted ? (
                    <div className="analysis-button-container">
                        {isAnalyzing ? (
                            <div className="analyzing-indicator">
                                <div className="typing-indicator analyzing">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <p>Analyzing talent match...</p>
                            </div>
                        ) : (
                            <Button 
                                className="btn-ai"
                                label={
                                            <div className="d-flex align-items-center">
                                                <img src={AISparkles} alt="" className="mr-1"/>
                                                <div>View Match Logic</div>
                                            </div>
                                        }
                                onClick={handleAnalysisStart}
                            />
                        )}
                       
                    </div>
                ) : (
                    <>
                        {displayText.split('\n').map((paragraph, index) => (
                            <p key={index} className="mb-1">
                                {paragraph}
                                {isTyping && index === displayText.split('\n').length - 1 && (
                                    <span className="typing-cursor"></span>
                                )}
                            </p>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
};

export default AIExplanationBox;
